<template>
<div>home</div>
</template>

<script>
export default {
  name: "Home"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home.vue